import { render, staticRenderFns } from "./SelectHouseholds.vue?vue&type=template&id=c41541bc&scoped=true"
import script from "./SelectHouseholds.vue?vue&type=script&lang=js"
export * from "./SelectHouseholds.vue?vue&type=script&lang=js"
import style0 from "./SelectHouseholds.vue?vue&type=style&index=0&id=c41541bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41541bc",
  null
  
)

export default component.exports